import {InfoPageLayout} from '../../../components/info-page-layout/info-page-layout.component';
import { useCabinet } from '../../../models/cabinet/cabinet-provider';
import {TabPanel, TabView} from 'primereact/tabview';
import { Badge } from 'primereact/badge';
import {PartnerForm} from '../../../domains/partnerForm';
import {useEffect, useState} from "react";
import {ConnectionsList} from "../../../domains/connectionsList";
import {EventsList} from "../../../domains/eventsList";
import {AccountTab} from "../../../domains/accountTab";

export const CabinetMainPage = () => {
  const [activeTab, setActiveTab] = useState<number>(1);
  const [accountTabReloadKey, setAccountTabReloadKey] = useState(0);

  const {
    partners,
    eventsTotal,
    refetch,
  } = useCabinet();

  const hasPartner = partners.length > 0;

  useEffect(() => {
    if (hasPartner) {
      setActiveTab(0);
      return;
    }
    setActiveTab(1);
  }, [hasPartner]);

  const infoTabIndex = hasPartner ? 1 : 0;
  const accountTabIndex = infoTabIndex + 1;

  useEffect(() => {
    if (activeTab !== accountTabIndex) {
      return;
    }
    setAccountTabReloadKey((prev) => prev + 1);
  }, [accountTabIndex, activeTab]);

  return (
    <InfoPageLayout title="Личный кабинет">
      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => setActiveTab(e.index)}
      >
        {
          hasPartner && (
            <TabPanel header="Заявления на ТП" key="tab1">
              <ConnectionsList />
            </TabPanel>
          )
        }
        <TabPanel header="Информация о заявителе" key="tab2">
          <PartnerForm onSaved={refetch} />
        </TabPanel>
        <TabPanel header="Учетная запись" key="tab-account">
          <AccountTab reloadKey={accountTabReloadKey} />
        </TabPanel>
        {
          hasPartner && (
            <TabPanel
              header={(
                <div style={{ position: 'relative', paddingRight: '1.25rem', display: 'inline-block' }}>
                  <span>События</span>
                  <Badge
                    value={eventsTotal}
                    severity="danger"
                    style={{ position: 'absolute', top: '-0.6rem', right: '-0.6rem' }}
                  />
                </div>
              )}
              key="tab3"
            >
              <EventsList />
            </TabPanel>
          )
        }
      </TabView>
    </InfoPageLayout>
  )
}